import { OptionsObject, SnackbarKey, SnackbarMessage, VariantType, useSnackbar } from 'notistack';
import { useEffect }                                                             from 'react';
const hideSidebarScreenWidth = 1280;
const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    || window.innerWidth <= hideSidebarScreenWidth;
const defaultOptions: OptionsObject = {
  preventDuplicate : true,
  anchorOrigin     : {
    vertical   : 'top',
    horizontal : 'right',
  },
  style: {
    whiteSpace: 'pre-line',
  },
  className: isMobile()? 'notistack-custom':'',
};

type TNotistack = any; // ProviderContext | () => null;

export const Notistack: TNotistack = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(
    () => {
      Notistack.enqueueSnackbar = (
        message: SnackbarMessage,
        variant?: VariantType,
        options?: OptionsObject
      ) => {
        enqueueSnackbar(
          message, {
            ...defaultOptions,
            ...options,
            variant,
          }
        );
      };
    },
    [ enqueueSnackbar ],
  );

  useEffect(
    () => {
      Notistack.closeSnackbar = (key?: SnackbarKey) => {
        closeSnackbar(key);
      };
    },
    [ closeSnackbar ],
  );

  return null;
};
